export const ENV: string = process.env.REACT_APP_ENV || 'production';
export const BASE_URL: string = 'https://2025housecurryevent.tw';
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://2025housecurryevent.tw/api/v1';
